export const CURRENT_USER = 'CURRENT_USER'
export const UPDATE_EMAIL = 'UPDATE_EMAIL'
export const UPDATE_PWD = 'UPDATE_PWD'

export const SET_DOMAIN_USERS_LIST = 'SET_DOMAIN_USERS_LIST'
export const ADD_USER_ITEMS = 'ADD_USER_ITEMS'
export const DELETE_USER_ITEM = 'DELETE_USER_ITEM'
